import { HttpService } from "../HttpService";

/**
 * Get statistics.
 * @param conf.type 
 * @returns {Promise<Number>}
 */
export async function getStatistics(type: string) {
  const response = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/federfarma/statistics/${type}`);
  return response.data?.result;
}
